import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the e-signature data URL for a single staff member. Only call when the signature is actually needed (e.g. PDF generation). */
export function useGetStaffEsignature(staffId: string | null) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['staff-esignature', staffId],
    queryFn: async () => {
      const response = await api.get('/staff/:id/esignature', { params: { id: staffId! } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.esignatureDataUrl
    },
    enabled: !!staffId,
  })
}
